export const settingAccommodation = {
    p1: `Informations de base`,
    p2: `Saisissez le nom et le logo que les utilisateurs verront lorsqu'ils commenceront leur processus de check-in. Si vous n'avez pas de logo, le logo WACheckin par défaut sera utilisé.`,
    p3: `Politiques de l'hébergement`,
    p4: `Personnalisez les politiques de votre hébergement. Ce seront les conditions que les clients accepteront lors de leur check-in.`,
    p5: `ESPAGNOL`,
    p6: `ANGLAIS`,
    p7: `Message de bienvenue`,
    p8: `Personnalisez le message de bienvenue que vos clients verront après avoir terminé leur check-in.`,
    p9: `Clés des chambres`,
    p10: `Enregistrez et gérez les chambres équipées de serrures intelligentes. Configurez les codes d'accès qui seront fournis aux clients après leur check-in pour faciliter leur entrée.`,
    p11: `Autorités compétentes`,
    p12: `Configurez la connexion avec les autorités locales pour l'envoi automatique des rapports de voyageurs. Saisissez le nom d'utilisateur et le mot de passe correspondant à la plateforme de chaque autorité compétente.`,
    p13: `Garde civile`,
    p14: `Police nationale`,
    p15: `Ertzaintza`,
    p16: `Mossos`,
    p17: `données d'accès`,
    p18: `L'entité est requise`,
    p19: `Le nom d'utilisateur est requis`,
    p20: `Le mot de passe est requis`,
    p21: `Erreur lors de la validation des données`,
    p22: `L'entité est requise`,
    p23: `Le nom d'utilisateur est requis`,
    p24: `Le mot de passe est requis`,
    p25: `Données mises à jour avec succès`,
    p26: `Erreur lors de la saisie des données de la police d'immigration`,
    p27: `Téléchargez le code QR de votre hébergement pour des check-ins rapides, obtenez le lien à envoyer directement aux clients.`,
    p28: `Modifier le code de sécurité de l'hébergement`,
    p29: `Nous vérifions l'identité des clients en comparant la photo de leur pièce d'identité ou passeport avec un selfie en temps réel.`,
    p30: `En activant cette option, les clients devront vérifier leur identité pendant le processus de check-in. Si la validation n'aboutit pas, ils ne pourront pas poursuivre le check-in.`,
    p31: `Erreur lors de l'activation de la vérification d'identité`,
    p32: `Paramètres de paiement`,
    p33: `Facturez les clients pendant le processus de check-in, en leur permettant de payer les services supplémentaires et les frais applicables.`,
    p34: `Code de sécurité de l'hébergement`,
    p35: `Hébergement`,
    p36: `Activez cette option pour envoyer automatiquement un message WhatsApp le jour du check-out, demandant aux clients d'évaluer leur expérience dans l'hébergement de 1 à 5.`,
    p37: `Saisissez l'URL du site d'avis que vous souhaitez configurer pour que vos clients laissent leurs opinions, que ce soit sur Google ou un autre site d'avis que vous utilisez. Cela contribue à améliorer la visibilité et la réputation de l'hébergement.`,
    p38: `Saisissez l'URL du site d'avis (ex. Google, TripAdvisor)`,
    p39: `Gérez votre hébergement`,
    p40: `Informations de base`,
    p41: `Politiques de l'hébergement`,
    p42: `Message de bienvenue`,
    p43: `QR de l'hébergement`,
    p44: `Paiements des clients`,
    p45: `Téléchargez le logo de l'hébergement`,
    p46: `Vous pouvez télécharger ou glisser une image dans la zone`,
    p47: `Design`,
    p48: `Politiques`,
    p49: `Bienvenue`,
    p50: `Région`,
    p51: `Espagnol`,
    p52: `Anglais`,
    p53: `Arabe`,
    p54:``,
    p55:``,
    p56:``,
    p57:``,
    p58:``,
    p59:``,
    p60:``,
    p61:``,
    p62:``,
    p63:``,
    p64:``,
    p65:``,
    p66:``,
    p67:``,
    p68:``,
    p69:``,
    p70:``,
};
